/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

/**
 * Local Imports
*/

import { ApiProvider } from '../util/Api';
import { Authenticator } from './Authenticator';
import { PageProvider } from './PageProvider';

/**
 * Exports
*/

/**
 * 
 */
export function EntryPoint(props) {
  return (
    <ApiProvider>
      <PageProvider>
        <BrowserRouter>
          <Authenticator { ...props } />
        </BrowserRouter>
      </PageProvider>
    </ApiProvider>
  );
}

EntryPoint.propTypes = {
  guest: PropTypes.oneOfType([ PropTypes.node, PropTypes.func ]).isRequired,
  verified: PropTypes.oneOfType([ PropTypes.node, PropTypes.func ]).isRequired
};